import PropTypes from 'prop-types';
import { Button } from '@celltrak/ui-components';
import noop from 'lodash/noop';

import { text } from '../../constants';

import styles from './ProfileFormActions.module.scss';

const ProfileFormActions = ({ handleCancel, handleSave, isSaveDisabled }) => (
  <div className={styles.buttonContainer}>
    <Button color="light" onClick={handleCancel}>
      {text.cancel}
    </Button>
    <Button color="primary" onClick={handleSave} disabled={isSaveDisabled}>
      {text.save}
    </Button>
  </div>
);

ProfileFormActions.propTypes = {
  handleCancel: PropTypes.func,
  handleSave: PropTypes.func,
  isSaveDisabled: PropTypes.bool,
};

ProfileFormActions.defaultProps = {
  handleCancel: noop,
  handleSave: noop,
  isSaveDisabled: false,
};

export default ProfileFormActions;
